import {
  BoardContainer,
  TitleContainer
} from "../../assets/GlobalStyles";
import React from "react";
import {useParams} from "react-router-dom";
import EventUnitPrice from "./EventUnitPrice";
import EventUnitPriceDetail from "./EventUnitPriceDetail";
import BudgetEvent from "./BudgetEvent";
import BudgetEventDetail from "./BudgetEventDetail";
import BudgetTime from "./BudgetTime";
import BudgetTimeDetail from "./BudgetTimeDetail";
import BudgetTimeList from "./BudgetTimeList";
import styled from "styled-components";

export default function Settings() {
  const params = useParams()
  const isTimeBudgetPage = [
    "settings",
    "budgetTime",
    "budgetTimeList",
    "budgetTimeDetail"
  ].includes(params.id);

  return (
    <main>
      <BoardContainer>
        <TitleContainer>
          <h1>설정</h1>
        </TitleContainer>
        {/* 이벤트 단가 관리 */}
        {isTimeBudgetPage && (
          <SettingsBodyCard>
            {params.id === 'budgetTimeList' && <BudgetTimeList/>}
            {params.id === 'budgetTimeDetail' && <BudgetTimeDetail/>}
            {['settings', 'budgetTime'].includes(params.id) && <BudgetTime/>}
          </SettingsBodyCard>
        )}
        {params.id === 'settingsDetail' && <EventUnitPriceDetail/>}
        {params.id === 'budgetEvent' && <BudgetEvent/>}
        {params.id === 'budgetEventDetail' && <BudgetEventDetail/>}
      </BoardContainer>
    </main>
  )
}

const SettingsBodyCard = styled.section`
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
  border: 1px solid #e5e8eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(31, 41, 55, 0.06);
`;
